import classes from 'components/common/ConfirmSaveModal/ConfirmSaveModal.module.scss';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { IConfirmSaveModalProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Modal } from 'components/DesignSystem/Modal';
import { Button, CustomizedModalBase, CustomizedRoundIcon } from 'components/common';

/**
 * Confirmation Modal.
 * @param {boolean}  isShowModal - determines if this modal is visible.
 * @param {() => void}  onHideModal - hide  modal function.
 * @param { React.ReactNode}  children - modal children.
 * @param {() => void}  onConfirm - form submit function.
 * @param { boolean}  isLoading - if data is fetching now.
 * @param { string}  actionButtonLabel - submit button text. (optional 'save' by default)
 * @returns  Modal
 * */
export const ConfirmSaveModal = ({
    isShowModal,
    onHideModal,
    children,
    onConfirm,
    isLoading = false,
    actionButtonLabel = 'Save',
}: IConfirmSaveModalProps) => {
    return (
        <Modal
            open={isShowModal}
            onClose={onHideModal}
            actions={
                <>
                    <Button size={'medium'} variant={'secondary'} onClick={() => onHideModal()} disabled={isLoading}>
                        Cancel
                    </Button>

                    <Button
                        size={'medium'}
                        variant={'primary'}
                        onClick={() => onConfirm()}
                        isLoading={isLoading}
                        disabled={isLoading}
                    >
                        {actionButtonLabel}
                    </Button>
                </>
            }
        >
            <div className={classes.deleteMessage}>
                <MuiIcon icon={'warning'} color={'var(--button-primary-bg_destructive)'} fontSize={'30px'} />
                <span className={classes.title}>{children}</span>
            </div>
        </Modal>
    );
};
